import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=2c90b80b&scoped=true"
import script from "./Talk.vue?vue&type=script&lang=js"
export * from "./Talk.vue?vue&type=script&lang=js"
import style0 from "./Talk.vue?vue&type=style&index=0&id=2c90b80b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90b80b",
  null
  
)

export default component.exports